// The account-level scope presented as "the default workspace" — the one every
// account starts with (docs with no workspaceId live there). One label helper
// so the switcher, copy modals, share dialog and run queue all name it the
// same way. The wire sentinel stays 'account' (utils/api.js) — only the words
// changed.

export const DEFAULT_WORKSPACE_SENTINEL = 'account';

/** "Acme (Default)" — the default workspace's display label. */
export function defaultWorkspaceLabel(accountName) {
  return `${accountName || 'Account'} (Default)`;
}
